var PasswordStrength = {
    None: 0,
    Weak: 1,
    Medium: 2,
    Strong: 4,
};

export { PasswordStrength };
